import SwellTooltip from "components/forecast-table/swell-tooltip/swell-tooltip"

function initTooltips(container) {
  const cells = container.querySelectorAll("[data-swell-state]")
  Array.from(cells).forEach((cell) => {
    const tooltip = new SwellTooltip(cell)
    tooltip.init()
  })
}

function SwellTooltipPlugin($pool) {
  const rowNames = ["wave-graph", "wave-height", "energy-sumenergy", "energy-maxenergy"]

  return function run(eventName, payload) {
    const { Controller } = payload

    if (eventName !== "Row:changeMode" && eventName !== "Table:connectContent") return
    if (eventName === "Row:changeMode" && !rowNames.includes(Controller.name)) return

    if (eventName === "Row:changeMode") {
      $pool.push("Table:changeMode::mutate", () => {
        initTooltips(Controller.cells[0].parentNode)
      })
    }

    if (eventName === "Table:connectContent") {
      $pool.push("Table:connectContent::finish", () => {
        initTooltips(payload.node)
      })
    }
  }
}

export default SwellTooltipPlugin
